import { ConfigActionType } from '../actionTypes/config';
import { ConfigurationType, FeatureSwitchType, PostDispatch } from '../types';

const INIT_FEATURE_SWITCH: FeatureSwitchType = {
    adminUserDelete: false,
    turnItInPlugin: false,
    addClmUsersManually: false,
    billing: false,
    languageSwitcher: false,
    addIntakesManually: false,
    adminCreateUserRoleAccount: false,
    gradingOptionalAssessment: false,
    gradingOptionalAgreeDisagree: false,
};
export const CONFIG_INIT: ConfigurationType = {
    featureSwitch: INIT_FEATURE_SWITCH,
    turnItInPluginMaxRetries: 1,
};

const configReducer = (
    state = CONFIG_INIT,
    action: PostDispatch
): ConfigurationType => {
    switch (action.type) {
        case ConfigActionType.GET_FRONT_CONFIGURATION:
            return action.payload as ConfigurationType;
        default:
            return state as ConfigurationType;
    }
};
export default configReducer;
